import { useCallback, useEffect, useState } from 'react';
import { staticIpStateType } from './type';
import { getUserStaticIpDetails, giftStaticIp } from 'v3/common/api/plans';
import { reactToastify, TOASTIFY_TYPES } from 'v3/common/utils/reactToastify';

const initialState: staticIpStateType = {
  userIPDetails: {
    status: '',
    ip: '',
  },
  isLoading: true,
  buttonLoader: false,
};

export const useStaticIP = () => {
  const [staticIpState, setStaticIpState] = useState<staticIpStateType>(initialState);

  const broker = window.currentUserBroker;
  const isPlanActive = window.SA_USER_FLAGS.isPlanActive;

  const onPartialStateChange = useCallback((newState: Partial<staticIpStateType>) => {
    setStaticIpState((prevState) => ({ ...prevState, ...newState }));
  }, []);

  const fetchUserStaticIp = useCallback(() => {
    onPartialStateChange({ isLoading: true });

    getUserStaticIpDetails(broker)
      .then((results: staticIpStateType['userIPDetails']) => {
        onPartialStateChange({ userIPDetails: results });
      })
      .catch(() => {})
      .finally(() => {
        onPartialStateChange({ isLoading: false });
      });
  }, [broker, onPartialStateChange]);

  useEffect(() => {
    fetchUserStaticIp();
  }, [fetchUserStaticIp]);

  const onHandleClaim = useCallback(() => {
    onPartialStateChange({ buttonLoader: true });

    giftStaticIp()
      .then((response) => {
        if (response?.status && response?.ip) {
          onPartialStateChange({ userIPDetails: response });
          reactToastify('Static IP claimed successfully', TOASTIFY_TYPES.SUCCESS);
        } else {
          reactToastify(response?.message || 'Something went wrong', TOASTIFY_TYPES.ERROR);
        }
      })
      .catch(() => {
        reactToastify('Failed to claim static IP', TOASTIFY_TYPES.ERROR);
      })
      .finally(() => {
        onPartialStateChange({ buttonLoader: false });
      });
  }, [onPartialStateChange]);

  return {
    staticIpState,
    onHandleClaim,
    canClaimIp: !staticIpState.userIPDetails?.ip && isPlanActive,
    refetchStaticIp: fetchUserStaticIp,
  };
};
